fragment ImageTextHoverFragment on imageTextHover_Entry {
  typeHandle
  tagLine
  hovers {
    ... on hoversBlock_Entry {
      claim
      image {
        url
        title
      }
      alt
      body
    }
  }
}
